import React from "react";

export const AdminSiteContext = React.createContext({});
